// Canvas "maitre" partage du dessin collaboratif. Toutes les vues (DrawBoard live,
// overlay de fin) blittent depuis ce canvas offscreen. Resolution fixe -> les
// coordonnees des segments sont dans cet espace, identiques pour tous les clients.
export const DRAW_W = 900;
export const DRAW_H = 560;

let canvas = null;
let ctx = null;
const subs = new Set();

function ensure() {
  if (canvas) return;
  canvas = document.createElement('canvas');
  canvas.width = DRAW_W;
  canvas.height = DRAW_H;
  ctx = canvas.getContext('2d');
  fillWhite();
}
function fillWhite() { ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, DRAW_W, DRAW_H); }
function paint(seg) {
  if (!seg) return;
  ctx.strokeStyle = seg.tool === 'eraser' ? '#ffffff' : seg.color;
  ctx.lineWidth = seg.size;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.beginPath();
  ctx.moveTo(seg.x0, seg.y0);
  ctx.lineTo(seg.x1, seg.y1);
  ctx.stroke();
}
function notify() { for (const f of subs) { try { f(); } catch { /* ignore */ } } }

export function applySegment(seg) { ensure(); paint(seg); notify(); }
export function initFrom(segments) { ensure(); fillWhite(); for (const s of (segments || [])) paint(s); notify(); }
export function resetDraw() { ensure(); fillWhite(); notify(); }
export function getCanvas() { ensure(); return canvas; }
export function subscribe(fn) { subs.add(fn); return () => subs.delete(fn); }

export async function copyDrawingToClipboard() {
  ensure();
  const blob = await new Promise((res) => canvas.toBlob(res, 'image/png'));
  if (!blob || !navigator.clipboard || !window.ClipboardItem) throw new Error('clipboard_unavailable');
  await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
  return true;
}
